import { Maybe } from '../../types/prismic';
import { ButtonProps } from '../components/ui/Button';

type UncertainPrismicString = Maybe<string> | undefined;

export type CKColorVariants =
  | 'terracotta'
  | 'herb'
  | 'stone'
  | UncertainPrismicString;

const getButtonVariant: (color: CKColorVariants) => ButtonProps['variant'] = (
  color: CKColorVariants
) => {
  switch (color) {
    case 'herb':
      return 'primary';
    case 'terracotta':
      return 'danger';
    case 'stone':
      return 'secondary';
    default:
      return 'primary';
  }
};

export default getButtonVariant;
